import YudlButton from "../../../components/Button";
import "./style.css";

const recentWorks = [
  { type: "tall narrow", position: 1 },
  { type: "short wide", position: 2 },
  { type: "short narrow", position: 3 },
  { type: "tall narrow", position: 4 },
  { type: "tall wide", position: 5 },
  { type: "short narrow", position: 6 },
];

const RecentWork = () => {
  return (
    <section id="recent-work">
      <h3 className="display-6 text-theme text-center mt-5 fw-bold">Our Recent Works</h3>
      <div className="my-5 d-flex justify-content-center">
        <div className="container-lg container-fluid recent-work-container p-lg-5 p-1">
          {recentWorks.map(work => (
            <div key={work.position} className={`work-item ${work.type}`}>
              <img
                src={`/assets/landing/project-${work.position}.png`}
                alt=""
                className="img-fluid w-100 h-100 work-img cursor-pointer"
              />
            </div>
          ))}
        </div>
      </div>
      <div className="d-flex justify-content-center my-5">
        <YudlButton buttonRole="link" link="/portfolio" children="View more of our work" />
      </div>
    </section>
  );
};

export default RecentWork;
